var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.5a2.5 2.5 0 015 0v6a2.5 2.5 0 01-5 0v-6z",
    fill: "#111",
    stroke: "#FFF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 1,
    width: 5,
    height: 11,
    rx: 2.5,
    fill: "#111",
    stroke: "#FFF",
    strokeWidth: 2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA2NCA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iNiIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMTAiIGZpbGw9IiMxMTExMTEiLz4KPHBhdGggZD0iTTE3IDMuNUMxNyAyLjExOTI5IDE4LjExOTMgMSAxOS41IDFDMjAuODgwNyAxIDIyIDIuMTE5MjkgMjIgMy41VjkuNUMyMiAxMC44ODA3IDIwLjg4MDcgMTIgMTkuNSAxMkMxOC4xMTkzIDEyIDE3IDEwLjg4MDcgMTcgOS41VjMuNVoiIGZpbGw9IiMxMTExMTEiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxyZWN0IHg9IjQyIiB5PSIxIiB3aWR0aD0iNSIgaGVpZ2h0PSIxMSIgcng9IjIuNSIgZmlsbD0iIzExMTExMSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgCalendar as ReactComponent };